export enum RequestHeaders {
  server = 'X-resilience-server',
  retries = 'X-resilience-retries',
  auth = 'Authorization',
}
